import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Dialog,
  DialogContent,
  DialogContentText,
  InputAdornment,
  IconButton,
  Checkbox,
  MenuItem,
  Snackbar,
  Typography,
} from "@mui/material";
import { useCreateCardDetailContext } from "../../../CreatecardDetailContext";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as TickIcon } from "../../../../Assets/img/icons/tick-shape.svg";
import { useQuantityContext } from "../../../QuantityContext";
import useNavigationGuard from "./useNavigationGuard";
import { useUserDetailContext } from "../../../UserDetailContext";
import FileDragUploadWithContext from "../../../Utilities/FileDragUploadWithContext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import loaderGif from "../../../../Assets/img/icons/Animation - 1718370478484.gif";
import CloseIcon from "@mui/icons-material/Close";
import { getAllCardDetailsReducer, getAllCardInfoReducer, patchProfessionalCardReducer, patchStudentCardReducer } from "../../../../Redux/Reducers/CardReducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

function AcademyDetails({ handleSuccess, handleFailure }) {
  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const [isDialogNewEmail, setisDialogNewEmail] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [code, setCode] = useState("");
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);
  const [verifyDisable, setVerifyDisable] = useState(false);
  const [showCode, setShowCode] = useState(false);
  const [showCodeError, setShowCodeError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cardNameError, setCardNameError] = useState("");
  const [cardNameError2, setCardNameError2] = useState("");
  const [optVerified, setOptVerified] = useState(false);

  const dispatch = useDispatch();
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };

  const { cardDetails, updateCardDetails } = useCreateCardDetailContext();
  const { userDetails } = useUserDetailContext();
  const [initialCardDetails, setInitialCardDetails] = useState({}); // Define initialCardDetails here
  const { setisNavigationBlocked, openSnackbar, handleInfo } = useQuantityContext();

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState({
    title: "",
    body: "",
  });

  const Allcards = useSelector((state) => state?.CardArray?.AllCardDetailsInfo);

  const filteredCardName = Allcards?.filter(
    (card) =>
      card?.card_name?.toLowerCase().trim() ===
      cardDetails?.CardName?.toLowerCase().trim()
  );

  const [currentEducation, setCurrentEducation] = useState({
    id: "",
    instlogo: { name: "", type: "", data: "" },
    certificatepic: { name: "", type: "", data: "" },
    eduLevel: "",
    universityName: "",
    fieldofStudy: "",
    institute: "",
    degree: "",
    grade: "",
    startYear: "",
    endYear: "",
    isCurrentlyPursuing: false,
    description: "",
    isPublic: true,
    month: "",
    year: "",
    fullName: "",
    studentId: "",
    verifyMethod: "",
    adminEmailId: "",
    studentEmailId: "",
    verifyDoc: { name: "", type: "", data: "" },
    isVerified: false,
  });

  useEffect(() => {
    setInitialCardDetails(cardDetails);
  }, []);

  useEffect(() => {
    setSaveEnable(
      JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails)
    );
    setisNavigationBlocked(
      JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails)
    );
  }, [cardDetails, initialCardDetails]);

  const [SaveEnable, setSaveEnable] = useState(false);
  const message = "You have some UnSaved Changes. Do u want to leave ?";
  useNavigationGuard(SaveEnable, setSaveEnable, message);

  const handleInputChange = (fieldName) => (event) => {
    const newValue = event.target.value;
    updateCardDetails({ [fieldName]: newValue });
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const isEnableVerifyButton = () => {
    let requiredFields = ["student_id", "student_year", "student_ending_year"];

    const isCommonFieldsFilled = requiredFields.every(
      (field) => cardDetails[field]
    );

    if (!isCommonFieldsFilled) return false;

    // Check fields based on the selected verifyMethod
    if (currentEducation.verifyMethod === "studentEmailId") {
      return cardDetails.student_email_id !== "";
    } else if (currentEducation.verifyMethod === "adminEmailId") {
      return currentEducation.adminEmailId !== "";
    } else if (currentEducation.verifyMethod === "verifyDoc") {
      return (
        currentEducation?.verifyDoc && currentEducation.verifyDoc.data !== ""
      );
    }

    return false;
  };

  const handleSaveCustom = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/card/personaldata`,
        cardDetails,
        {
          headers: headers,
        }
      );

      console.log("Response from backend:", response.data);
      setInitialCardDetails(cardDetails);
      handleSuccess();
    } catch (error) {
      console.error("Error submitting card details:", error);
      handleFailure();
    }
  };

  const toggleCodeVisibility = () => {
    setShowCode((prev) => !prev);
  };

  // const sendOtpNewEmail = () => {
  //   if (!emailId.includes("@") || emailId.trim() === "") {
  //     // alert("enter the valid email");
  //     setCardNameError("Enter a Valid Email");
  //   } else {
  //     setCardNameError();
  //     SendingOTP();
  //   }
  // };
  // const handleLogo = async () => {

  //   try {
  //     // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/verify/get-url-data`, {
  //     //     "student_email": cardDetails.student_email_id,
  //     //     "logo_fetch":false
  //     // }, {
  //     //     headers: headers
  //     // });
  //     //   const response = await axios.get();
  //     setVerifyDisable(true);
  //     openSnackbar("Verifying your domain...", "info", 200000);
  //     const domain = cardDetails.student_email_id.split("@")[1];
  //     const response = await fetch(
  //       `https://logoapi.onrender.com/logo?domain=${domain}`,
  //       {
  //         method: "GET", // Adjust method if necessary
  //       }
  //     ).then((res) => res.json());

  //     // console.log("response", response);

  //     // console.log("Response from backend veirfy:", response.logo);

  //     if (response.logo) {
  //       // SendingOTP();
  //       handleInfo("Please wait to complete the process.");
  //       // sendOtpNewEmail();

  //       if (response.logo) {
  //         const fetchedLogo = response.logo;

  //         let bloblogo;
  //         if (fetchedLogo) {
  //           const payloadlogo = {
  //             logo: fetchedLogo, // Include the logo URL
  //           };

  //           bloblogo = await axios.post(
  //             `${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url-from-url`,
  //             payloadlogo,
  //             {
  //               headers: headers,
  //             }
  //           );
  //         }
  //         // console.log("blob url", bloblogo);

  //         const payload = { ...cardDetails, logo: bloblogo?.url };

  //         // const payload = {
  //         //   ...cardDetails,
  //         //   logo: fetchedLogo,
  //         // };
  //         try {
  //           const logoResponse = await axios.post(
  //             `${process.env.REACT_APP_BACKEND_URL}/card/personaldata`,
  //             payload,
  //             {
  //               headers: headers,
  //             }
  //           );

  //           console.log("Logo Response", logoResponse);
  //           if (logoResponse.status === 201) {
  //             console.log("Logo is updated");
  //             updateCardDetails({ logo: fetchedLogo });
  //             updateCardDetails({ ["is_professional_verified"]: true });
  //           }
  //         } catch (error) {
  //           console.log("Could not set the fetched logo:", fetchedLogo);
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error verifying details:", error);
  //   }
  // }

  const SendingOTP = async () => {
    if (
      !currentEducation.adminEmailId.includes("@") ||
      currentEducation.adminEmailId.trim() === ""
    ) {
      // alert("enter the valid email");
      setCardNameError("Enter a Valid Email");
    } else {
      setCardNameError();
      setMinutes(0);
      setSeconds(60);
      setisDialogNewEmail(true);
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-second-otp`,
          {
            email: cardDetails.student_email_id,
          },
          { headers: headers }
        )
        .then((response) => {
          console.log("OTP sent successfully");
          // optVerified(true);
        })
        .catch((error) => {
          // Handle error, such as displaying an error message to the user
          console.error("Failed to send OTP:", error);
        });
    }
  };

  const handleCodeSubmitNewEmail = async () => {
    try {
      // Proceed with OTP verification
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-verify-otp`,
          {
            email: cardDetails.student_email_id,
            otp: code,
          },
          { headers: headers }
        )
        .then(async (response) => {
          setCode("");
          setErrorMessage("");
          setisDialogNewEmail(false);
          // const data = handleLogo();
          // console.log(data);

          // updateCardDetails({ ["is_professional_verified"]: true });
          updateCardDetails({ ["is_student_verified"]: true });
          handleSuccess("Email Verified Successfully!");

          // setOptVerified(true);
        })
        .catch((error) => {
          setErrorMessage("Incorrect OTP. Please try again.");
          console.error("Failed to verify OTP:", error);
        });
    } catch (error) {
      console.error("Error in domain verification or OTP submission:", error);
    }
  };

  const handleChangeEducationItems = (fieldName) => (event) => {
    const newValue = event.target.value;
    const updatedField = { [fieldName]: newValue };
    const updatedEducation = { ...currentEducation, ...updatedField };
    updateCurrentEducation(updatedField);
    setVerifyDisable(false)
  };

  const updateCurrentEducation = (updatedField) => {
    //with both Key and Pair
    setCurrentEducation((prevEducation) => ({
      ...prevEducation,
      ...updatedField,
    }));
  };

  const handlecloseDialog = () => {
    // setErrorMessage('');

    setisDialogNewEmail(false);
    // setisDialogOldEmail(false);
  };

  const handleSave = async (event) => {
    event.preventDefault();

    if (
      cardDetails?.CardType?.startsWith("Customize_") &&
      (cardDetails.CardName === "" || cardDetails.CardName === null)
    ) {
      handleInfo("CardName should not be Empty, Fill it in Personal Details");
      return;
    }

    try {
      // console.log("cardDetails.student_ending_year",cardDetails.student_ending_year)
      // if (cardDetails.student_ending_year === "Present") {
      //     updateCardDetails({student_ending_year:Date.now()})
      // }



      // let updatedDetail = { ...cardDetails };
      // if (cardDetails.student_ending_year === "Present") {
      //   updatedDetail({ student_ending_year: new Date().getFullYear() });
      // }
      // const response = await axios.post(
      //   `${process.env.REACT_APP_BACKEND_URL}/card/personaldata`,
      //   cardDetails,
      //   {
      //     headers: headers,
      //   }
      // );

      // console.log("Response from backend:", response.data);
      // await dispatch(getAllCardDetailsReducer());
      // await dispatch(getAllCardInfoReducer());
      // setInitialCardDetails(cardDetails);
      // const payload = { ...cardDetails };

      // delete payload.CardName;

      const formData = new FormData();


      const appendIfDefined = (key, value) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      };

      appendIfDefined('User_ID', cardDetails?.User_ID);
      appendIfDefined('CardType', cardDetails?.CardType);
      // appendIfDefined('CardName', cardDetails?.CardName);
      appendIfDefined('employee_id', cardDetails?.employee_id);
      appendIfDefined('company_id', cardDetails?.company_id);
      appendIfDefined('profession_department', cardDetails?.profession_department);
      // appendIfDefined('employee_id', cardDetails?.employee_id);
      appendIfDefined('company_id', cardDetails?.company_id);
      appendIfDefined('location', cardDetails?.location);
      appendIfDefined('location_type', cardDetails?.location_type);
      appendIfDefined('profile_headline', cardDetails?.profile_headline);
      // appendIfDefined('responsibility', cardDetails?.responsibility.join(", "));

      appendIfDefined(
        'responsibility',
        Array.isArray(cardDetails?.responsibility)
          ? cardDetails.responsibility.join(", ")
          : cardDetails?.responsibility || ""
      );
      appendIfDefined('profession_id', cardDetails?.profession_id);
      appendIfDefined('company_website', cardDetails?.company_website);
      appendIfDefined('is_professional_verified', cardDetails?.is_professional_verified ? 1 : 0);
      appendIfDefined('professional_details_status', cardDetails?.professional_details_status);
      appendIfDefined('student_id', cardDetails?.student_id);
      appendIfDefined('student_email_id', cardDetails?.student_email_id);
      appendIfDefined('student_year', cardDetails?.student_year);
      appendIfDefined('student_ending_year', cardDetails?.student_currently_pursuing ? new Date().getFullYear() : cardDetails?.student_ending_year);
      appendIfDefined('student_currently_pursuing', cardDetails?.student_currently_pursuing ? 1 : 0);
      appendIfDefined('educational_level', cardDetails?.education_level);
      appendIfDefined('institute', cardDetails?.institute);
      appendIfDefined('start_year', cardDetails?.start_year);

      // appendIfDefined('end_year', cardDetails?.student_currently_pursuing ? new Date().getFullYear() : cardDetails?.student_ending_year);
      appendIfDefined('end_year', cardDetails?.is_experience_current ? new Date().getFullYear() : cardDetails?.end_year);
      appendIfDefined('board', cardDetails?.board);
      appendIfDefined('degree', cardDetails?.degree);
      appendIfDefined('field_of_study', cardDetails?.field_of_study);
      appendIfDefined('grade', cardDetails?.grade);
      appendIfDefined('institute_domain', cardDetails?.institute_domain);
      appendIfDefined('university_website', cardDetails?.university_website);
      appendIfDefined('is_student_verified', cardDetails?.is_student_verified ? 1 : 0);
      appendIfDefined('student_details_status', cardDetails?.student_details_status);
      appendIfDefined('prefix', cardDetails?.prefix);
      appendIfDefined('suffix', cardDetails?.suffix);
      appendIfDefined('title', cardDetails?.title);
      appendIfDefined('nickname', cardDetails?.nickname);
      appendIfDefined('summary', cardDetails?.summary);
      appendIfDefined('designation', cardDetails?.role_title);
      appendIfDefined('company', cardDetails?.company);
      appendIfDefined('professional_email_id', cardDetails?.professional_email_id);

      appendIfDefined('is_currently_working', Boolean(cardDetails?.is_experience_current) ? true : false);
      appendIfDefined('DOB', cardDetails?.DOB);
      appendIfDefined('role_title', cardDetails?.role_title);
      appendIfDefined('details', cardDetails?.details);



      if (cardDetails?.additionalFields) {
        Object.entries(cardDetails.additionalFields).forEach(([key, value]) => {
          appendIfDefined(`additionalFields[${key}]`, value);
        });
      }

      if (cardDetails?.profile_pic) {

        const response = await fetch(cardDetails?.profile_pic);
        const blob = await response.blob();
        appendIfDefined('profile_pic', blob);

      }


      if (cardDetails?.logo) {
        const logoUrl = cardDetails?.logo?.data || cardDetails?.logo;

        if (logoUrl.startsWith("blob:")) {
          setLoading(true);
          handleInfo("Please wait to complete the process");

          try {
            const response = await fetch(logoUrl);
            const blob = await response.blob();
            const file = new File([blob], cardDetails?.logo?.name, { type: cardDetails?.logo?.type });
            appendIfDefined("logo_file", blob, cardDetails?.logo?.name);
          } catch (error) {
            console.error("Error fetching File", error);
          }

          setLoading(false);
        } else {
          appendIfDefined("logo", logoUrl);
        }
      }


      if (cardDetails?.CardType === "Student" || cardDetails?.CardType === "Customize_Student") {

        const resolvedCardId = isNaN(cardDetails?.card_id)
          ? filteredCardName?.[0]?.id
          : cardDetails?.card_id;

        // const response = await dispatch(patchProfessionalCardReducer({ id: resolvedCardId, data: formData }));
        const response = await dispatch(patchStudentCardReducer({
          id: Number(resolvedCardId), data: formData
        }));
        console.log("RESPONSE IN THE Professional update", response);
        await dispatch(getAllCardDetailsReducer());
        await dispatch(getAllCardInfoReducer());


        setInitialCardDetails(cardDetails);
        // updateCardDetails({ ["is_professional_verified"]: true });
        updateCardDetails({ ["is_student_verified"]: true });
        // handleSuccess();
      }

      handleSuccess();
    } catch (error) {
      console.error("Error submitting card details:", error);
      handleFailure();
    }
  };

  const handleCodeChange = (event) => {
    setCode(event.target.value);
    setShowCodeError(false);
    // setErrorMessage('');
  };

  const sendOtpNewEmail = () => {
    SendingOTP();
  };

  const handleVerify = async (event) => {
    event.preventDefault();
    if (currentEducation.verifyMethod == "studentEmailId") {
      if (
        !cardDetails.student_email_id.includes("@") ||
        cardDetails.student_email_id.trim() === ""
      ) {
        setCardNameError2("Enter the valid Email");
      } else {
        setCardNameError2();
        if (cardDetails.student_email_id) {
          // alert("inside the handle verify");
          sendOtpNewEmail();
          setisDialogNewEmail(true);
          // alert("after sending otp");

          // handleLogo();

          // try {
          //   // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/verify/get-url-data`, {
          //   //     "student_email": cardDetails.student_email_id,
          //   //     "logo_fetch":false
          //   // }, {
          //   //     headers: headers
          //   // });
          //   //   const response = await axios.get();
          //   setVerifyDisable(true);
          //   openSnackbar("Verifying your domain...", "info", 200000);
          //   const domain = cardDetails.student_email_id.split("@")[1];
          //   const response = await fetch(
          //     `https://logoapi.onrender.com/logo?domain=${domain}`,
          //     {
          //       method: "GET", // Adjust method if necessary
          //     }
          //   ).then((res) => res.json());

          //   // console.log("response", response);

          //   // console.log("Response from backend veirfy:", response.logo);

          //   if (response.logo) {
          //     // SendingOTP();
          //     handleSuccess("Domain Verified! Sending OTP...");
          //     // sendOtpNewEmail();

          //     if (response.logo) {
          //       const fetchedLogo = response.logo;

          //       let bloblogo;
          //       if (fetchedLogo) {
          //         const payloadlogo = {
          //           logo: fetchedLogo, // Include the logo URL
          //         };

          //         bloblogo = await axios.post(
          //           `${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url-from-url`,
          //           payloadlogo,
          //           {
          //             headers: headers,
          //           }
          //         );
          //       }
          //       // console.log("blob url", bloblogo);

          //       const payload = { ...cardDetails, logo: bloblogo?.url };

          //       // const payload = {
          //       //   ...cardDetails,
          //       //   logo: fetchedLogo,
          //       // };
          //       try {
          //         const logoResponse = await axios.post(
          //           `${process.env.REACT_APP_BACKEND_URL}/card/personaldata`,
          //           payload,
          //           {
          //             headers: headers,
          //           }
          //         );

          //         console.log("Logo Response", logoResponse);
          //         if (logoResponse.status === 201) {
          //           console.log("Logo is updated");
          //           updateCardDetails({ logo: fetchedLogo });
          //         }
          //       } catch (error) {
          //         console.log("Could not set the fetched logo:", fetchedLogo);
          //       }
          //     }
          //   }
          // } catch (error) {
          //   console.error("Error verifying details:", error);
          // }

        }
        setVerifyDisable(false);
      }
    } else if (currentEducation.verifyMethod === "adminEmailId") {
      if (
        !currentEducation.adminEmailId.includes("@") ||
        currentEducation.adminEmailId.trim() === ""
      ) {
        setCardNameError("Enter valid email");
      } else {
        setCardNameError();
        if (currentEducation.adminEmailId) {
          const formData = new FormData();
          formData.append(
            "studentDetails",
            JSON.stringify({
              selectedOption: "admin_mail",
              name: userDetails?.name || "User",
              student_id: cardDetails?.student_id || "",
              card_name: cardDetails?.CardName,
              card_type: cardDetails?.CardType,
              admin_email: currentEducation.adminEmailId,
            })
          );

          // Append the file if you have one, for example, `file` is obtained from a file input
          // formData.append('documents', file);  // Uncomment this line if you have a file to upload

          try {
            openSnackbar("Sending E-mail to your Institute Admin", "info", 5000);
            setVerifyDisable(true);
            const response = await axios.post(
              `${process.env.REACT_APP_BACKEND_URL}/card/verification-option`,
              formData,
              { headers }
            );

            console.log("Response from backend status:", response.data.status);

            if (response.data.status === "SUCCESS") {
              setLoading(false);
              handleSuccess("Verified message Successfully sent to the mail!");
              setVerifyDisable(false);
              // handleSaveCustom();
            } else if (response.data.status === "ERROR") {
              setLoading(false);
              handleFailure("Could Not Verify.");
            }
          } catch (error) {
            setLoading(false);
            handleFailure("Could Not Verify.");
          }
        }
        setVerifyDisable(false);
      }
    }
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    updateCardDetails({
      student_currently_pursuing: checked,
      student_ending_year: "Present",
    });
  };
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 1970 + 1 },
    (_, index) => currentYear - index
  );

  // if (loading) {
  //   return (
  //     <div className="loader-container">
  //       <img src={loaderGif} alt="Loading..." height={100} width={100} />
  //     </div>
  //   );
  // }

  return (
    <>
      <div>
        <div>
          {/* <Box className='my-4 card-info-box' sx={{ border: "1px solid #17b200", backgroundColor: "white", borderRadius: 2, paddingTop: "16px" }}> */}
          <div style={{ paddingRight: "16px", paddingLeft: "16px" }}>
            <div className="card-edit-info-heading">
              <h5>Academic Details</h5>
              <span>
                Please note that this information won't appear on the card while
                sharing
              </span>
              <p className="text-display-details">
                *Confidential information, share options not available{" "}
              </p>
            </div>

            <div className="my-2 user-details-container">
              <Grid container spacing={2}>
                {/* First Column */}
                <Grid item xs={6}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      <TextField
                        label="Student ID"
                        fullWidth
                        value={cardDetails?.student_id || ""}
                        onChange={handleInputChange("student_id")}
                        inputProps={{ maxLength: 18 }}
                        required
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        label="Starting Year"
                        fullWidth
                        value={cardDetails?.student_year || ""}
                        onChange={handleInputChange("student_year")}
                        select
                        required
                      >
                        {years.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={cardDetails?.student_currently_pursuing}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Currently Pursuing"
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={6}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      <TextField
                        label="Student Email ID"
                        fullWidth
                        value={cardDetails?.student_email_id || ""}
                        onChange={handleInputChange("student_email_id")}
                        required
                        inputProps={{ maxLength: 48 }}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        label="Ending Year"
                        fullWidth
                        value={cardDetails?.student_ending_year || ""}
                        onChange={handleInputChange("student_ending_year")}
                        select
                        required
                        disabled={cardDetails.student_currently_pursuing}
                      >
                        {years.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                        {cardDetails.student_currently_pursuing && (
                          <MenuItem value="Present">Present</MenuItem>
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={6}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      <TextField
                        name="verifyMethod"
                        label="Verification Method"
                        onChange={handleChangeEducationItems("verifyMethod")}
                        fullWidth
                        select
                      >
                        <MenuItem value="studentEmailId">
                          My Institute E-mail ID
                        </MenuItem>
                        <MenuItem value="adminEmailId">
                          My Institute Admin E-mail ID
                        </MenuItem>
                        <MenuItem value="verifyDoc">
                          Upload Verification Document
                        </MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      {currentEducation.verifyMethod !== "" && (
                        <>
                          {currentEducation.verifyMethod ===
                            "studentEmailId" && (
                              <TextField
                                name="studentId"
                                label="Student Email ID"
                                inputProps={{ maxLength: 50 }}
                                value={
                                  cardDetails?.student_email_id ||
                                  currentEducation.EmailId
                                }
                                onChange={handleChangeEducationItems(
                                  "studentEmailId"
                                )}
                                fullWidth
                                helperText="Verify your academic details securely using your institute's student ID."
                              />
                            )}
                          {cardNameError2 && (
                            <Typography variant="body2" color="error">
                              {cardNameError2}
                            </Typography>
                          )}
                          {currentEducation.verifyMethod === "adminEmailId" && (
                            <TextField
                              name="adminId"
                              label="Admin Email ID"
                              value={currentEducation.adminEmailId}
                              onChange={handleChangeEducationItems(
                                "adminEmailId"
                              )}
                              fullWidth
                              helperText="Verify your academic details securely using your institute's admin ID."
                              inputProps={{ maxLength: 48 }}
                            />
                          )}
                          {cardNameError && (
                            <Typography variant="body2" color="error">
                              {cardNameError}
                            </Typography>
                          )}
                          {currentEducation.verifyMethod === "verifyDoc" && (
                            <FileDragUploadWithContext
                              label="Upload Verification Document"
                              maxSize={5}
                              inputId="verifyEduDoc"
                              contextKey="verifyDoc"
                              context={currentEducation}
                              updateContext={updateCurrentEducation}
                              accept={[
                                "image/jpeg",
                                "image/png",
                                "application/pdf",
                              ]}
                            />
                          )}
                        </>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <FormControlLabel
                control={<Switch disabled />}
                label="Disabled"
              />
            </div>
          </div>

          <div
            className="save-bottom-container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              backgroundColor: "#0044C614",
              padding: "12px",
              borderRadius: "0 0 8px 8px",
            }}
          >
            {/* Left-aligned Verify button */}
            <div className="save-bottom" style={{ textAlign: "left" }}>

              {cardDetails?.is_student_verifieds ?
                <Button variant="contained" className="verify-button success-green" disabled>
                  Verified
                </Button> :
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#0044C6" }}
                  onClick={!verifyDisable ? handleVerify : undefined}
                >
                  Verify
                </Button>}
            </div>

            {/* Right-aligned Save button */}
            <div className="save-bottom" style={{ textAlign: "right" }}>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#0044C6" }}
                onClick={handleSave}
                disabled={!SaveEnable}
              >
                Save
              </Button>
            </div>
          </div>

          {/* <div className="save-bottom" style={{ textAlign: "right", backgroundColor: "#0044C614", padding: "12px", borderRadius: "0 0 8px 8px" }}>
                    <Button variant='contained' sx={{ backgroundColor: "#0044C6" }} onClick={handleSave} disabled={!SaveEnable}>Save</Button>
                </div> */}
          <ToastContainer toastClassName="email-toast-success" />
          {/* </Box> */}
        </div>
      </div>

      {isDialogNewEmail && (
        <Dialog
          open={isDialogNewEmail}
          // onClose={handleCloseVerifiedDialog}
          aria-labelledby="Enable 2FA (Two-factor Authentication)"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className="dialogContainer">
            <DialogContentText className="dialogText">
              <div>
                <p className="mt-10 onboard_header_align">
                  Two-factor Authentication
                </p>
                <p className="paragraph-text">Verify your new E-mail ID</p>
                <button
                  type="button"
                  className="lightbox__close"
                  onClick={handlecloseDialog}
                >
                  &times;
                </button>
                <div>
                  <div className="">
                    <div>
                      <TextField
                        type={showCode ? "text" : "password"}
                        value={code}
                        onChange={handleCodeChange}
                        error={showCodeError}
                        helperText={showCodeError ? "Code is required" : ""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={minutes === 0 && seconds === 0}
                        className={`text-field-outline input-text d-flex ${showCodeError ? "error-textfield" : ""
                          }`}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={toggleCodeVisibility}>
                                {showCode ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>

                    {errorMessage ? (
                      <div style={{ color: "red", marginTop: "10px" }}>
                        {errorMessage}
                      </div>
                    ) : (
                      <div style={{ marginTop: "10px" }}></div>
                    )}

                    <div className="justify-content-space-bw-login mt-20">
                      <div className="resent-otp">
                        Remaining Time: {minutes < 10 ? `0${minutes}` : minutes}
                        :{seconds < 10 ? `0${seconds}` : seconds}
                      </div>

                      <div
                        className="next-button-container"
                        style={{ gap: "16px" }}
                      >
                        <button
                          className={`next-btn ${code.trim() === "" ? "disabled" : ""
                            }`}
                          type="submit"
                          onClick={handleCodeSubmitNewEmail}
                          disabled={code.trim() === ""}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                    <div className="resent-otp-design mt-20">
                      Didn't get the mail?{" "}
                      <button
                        className="button-style-height"
                        onClick={sendOtpNewEmail}
                      >
                        RESEND
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message="Verification message sent to the admin"
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleCloseSnackbar}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        anchorOrigin={{
          vertical: "top", // Position at the top
          horizontal: "right", // Position at the right
        }}
      />
    </>
  );
}

export default AcademyDetails;
